// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound-space1-YpsrP {
	margin-bottom: 6px !important;
}

.NotFound-space2-MWedW {
	margin-bottom: 12px !important;
}

.NotFound-space3-raqb4 {
	margin-bottom: 18px !important;
}

.NotFound-space4-ziYe5 {
	margin-bottom: 24px !important;
}

.NotFound-space5-A_VoZ {
	margin-bottom: 30px !important;
}

.NotFound-space6-CQ39A {
	margin-bottom: 36px !important;
}

.NotFound-space7-W9DLB {
	margin-bottom: 42px !important;
}

.NotFound-space8-rerCN {
	margin-bottom: 48px !important;
}

.NotFound-spaceTop1-aNKK1 {
	margin-top: 6px !important;
}

.NotFound-spaceTop2-s0U3X {
	margin-top: 12px !important;
}

.NotFound-spaceTop3-DVcMV {
	margin-top: 18px !important;
}

.NotFound-spaceTop4-z3tPC {
	margin-top: 24px !important;
}

.NotFound-spaceTop5-H1nGd {
	margin-top: 30px !important;
}

.NotFound-spaceTop6-JPsJc {
	margin-top: 36px !important;
}

.NotFound-spaceTop7-ugapR {
	margin-top: 42px !important;
}

.NotFound-spaceTop8-Lyudx {
	margin-top: 48px !important;
}

.NotFound-noMargin-dxadb {
	margin: 0px !important;
}

.NotFound-padding1-a0kXZ {
	padding-bottom: 6px !important;
}

.NotFound-padding2-HZIHK {
	padding-bottom: 12px !important;
}

.NotFound-padding3-LqBLw {
	padding-bottom: 18px !important;
}

.NotFound-padding4-LCyHN {
	padding-bottom: 24px !important;
}

.NotFound-padding5-ifAXq {
	padding-bottom: 30px !important;
}

.NotFound-padding6-zuzHT {
	padding-bottom: 36px !important;
}

.NotFound-padding7-wYciG {
	padding-bottom: 42px !important;
}

.NotFound-paddingTop1-n2ZVY {
	padding-top: 6px !important;
}

.NotFound-paddingTop2-M4EvQ {
	padding-top: 12px !important;
}

.NotFound-paddingTop3-iMzmD {
	padding-top: 18px !important;
}

.NotFound-paddingTop4-ShVel {
	padding-top: 24px !important;
}

.NotFound-paddingTop5-taujh {
	padding-top: 30px !important;
}

.NotFound-paddingTop6-y60By {
	padding-top: 36px !important;
}

.NotFound-paddingTop7-mzeR6 {
	padding-top: 42px !important;
}

.NotFound-noPadding-whPzu {
	padding: 0px !important;
}

.NotFound-spaceMarginBottom0-N6vaH {
	margin-bottom: 0;
}

.NotFound-textBold-ElOpU {
	font-weight: 500 !important;
}

.NotFound-textBolder-iMAjX {
	font-weight: 700 !important;
}

.NotFound-textNormal-CczLX {
	font-weight: normal !important;
}

/*New Design Text Colors */

.NotFound-textDarkBlue-kO26X {
	color: rgb(20, 39, 94) !important;
}

.NotFound-textLightBlue-ORULj {
	color: rgb(57, 87, 106) !important;
}

.NotFound-textLightSandleGreen-i5ZwA {
	color: rgb(76, 86, 41) !important;
}

.NotFound-textLightBrown-WpTOn {
	color: rgb(115, 79, 33) !important;
}

.NotFound-textMediumMaroon-zutx1 {
	color: rgb(87, 37, 51) !important;
}

.NotFound-textBrown-wTWez {
	color: rgb(160, 47, 24) !important;
}

.NotFound-textMaroon-xzVsH {
	color: rgb(155, 49, 67) !important;
}

.NotFound-textDarkBrown-S4spU {
	color: rgb(83, 18, 16) !important;
}

.NotFound-textMediumBrown-b6zo0 {
	color: rgb(142, 28, 10) !important;
}

.NotFound-textSkyBlue-fTet2 {
	color: rgb(37, 117, 141) !important;
}

.NotFound-textGray-gMub1 {
	color: rgb(77, 65, 51) !important;
}

.NotFound-root-IuBXY {
	padding-left: 20px;
	padding-right: 20px;
}

.NotFound-container-ZTxRm {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: var(--max-content-width);
}

.NotFound-textJumbo-s8XDZ {
	font-size: 145px;
	font-weight: bold;
	margin: 0;
}

.NotFound-textMedium-hwXWT {
	font-size: 85px;
	font-weight: bold;
	margin: 0;
}

.NotFound-listStyled-TajNK {
	padding-left: 0;
	list-style: none;
}

.NotFound-subTitle-He_1D {
	font-size: 15px;
	color: var(--common-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/notFound/NotFound.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1LA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: var(--max-content-width);\n}\n\n.textJumbo {\n\tfont-size: 145px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 85px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.listStyled {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.subTitle {\n\tfont-size: 15px;\n\tcolor: var(--common-text-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `NotFound-space1-YpsrP`,
	"space2": `NotFound-space2-MWedW`,
	"space3": `NotFound-space3-raqb4`,
	"space4": `NotFound-space4-ziYe5`,
	"space5": `NotFound-space5-A_VoZ`,
	"space6": `NotFound-space6-CQ39A`,
	"space7": `NotFound-space7-W9DLB`,
	"space8": `NotFound-space8-rerCN`,
	"spaceTop1": `NotFound-spaceTop1-aNKK1`,
	"spaceTop2": `NotFound-spaceTop2-s0U3X`,
	"spaceTop3": `NotFound-spaceTop3-DVcMV`,
	"spaceTop4": `NotFound-spaceTop4-z3tPC`,
	"spaceTop5": `NotFound-spaceTop5-H1nGd`,
	"spaceTop6": `NotFound-spaceTop6-JPsJc`,
	"spaceTop7": `NotFound-spaceTop7-ugapR`,
	"spaceTop8": `NotFound-spaceTop8-Lyudx`,
	"noMargin": `NotFound-noMargin-dxadb`,
	"padding1": `NotFound-padding1-a0kXZ`,
	"padding2": `NotFound-padding2-HZIHK`,
	"padding3": `NotFound-padding3-LqBLw`,
	"padding4": `NotFound-padding4-LCyHN`,
	"padding5": `NotFound-padding5-ifAXq`,
	"padding6": `NotFound-padding6-zuzHT`,
	"padding7": `NotFound-padding7-wYciG`,
	"paddingTop1": `NotFound-paddingTop1-n2ZVY`,
	"paddingTop2": `NotFound-paddingTop2-M4EvQ`,
	"paddingTop3": `NotFound-paddingTop3-iMzmD`,
	"paddingTop4": `NotFound-paddingTop4-ShVel`,
	"paddingTop5": `NotFound-paddingTop5-taujh`,
	"paddingTop6": `NotFound-paddingTop6-y60By`,
	"paddingTop7": `NotFound-paddingTop7-mzeR6`,
	"noPadding": `NotFound-noPadding-whPzu`,
	"spaceMarginBottom0": `NotFound-spaceMarginBottom0-N6vaH`,
	"textBold": `NotFound-textBold-ElOpU`,
	"textBolder": `NotFound-textBolder-iMAjX`,
	"textNormal": `NotFound-textNormal-CczLX`,
	"textDarkBlue": `NotFound-textDarkBlue-kO26X`,
	"textLightBlue": `NotFound-textLightBlue-ORULj`,
	"textLightSandleGreen": `NotFound-textLightSandleGreen-i5ZwA`,
	"textLightBrown": `NotFound-textLightBrown-WpTOn`,
	"textMediumMaroon": `NotFound-textMediumMaroon-zutx1`,
	"textBrown": `NotFound-textBrown-wTWez`,
	"textMaroon": `NotFound-textMaroon-xzVsH`,
	"textDarkBrown": `NotFound-textDarkBrown-S4spU`,
	"textMediumBrown": `NotFound-textMediumBrown-b6zo0`,
	"textSkyBlue": `NotFound-textSkyBlue-fTet2`,
	"textGray": `NotFound-textGray-gMub1`,
	"root": `NotFound-root-IuBXY`,
	"container": `NotFound-container-ZTxRm`,
	"textJumbo": `NotFound-textJumbo-s8XDZ`,
	"textMedium": `NotFound-textMedium-hwXWT`,
	"listStyled": `NotFound-listStyled-TajNK`,
	"subTitle": `NotFound-subTitle-He_1D`
};
module.exports = ___CSS_LOADER_EXPORT___;
